<template>
    <v-navigation-drawer
        v-model="userOptions.sidebar.isOpen"
        :mini-variant="userOptions.sidebar.miniVariant"
        :expand-on-hover="userOptions.sidebar.expandOnHover"
        app
        :permanent="userOptions.sidebar.isOpen ?? true"
        style="scrollbar-width: none; overflow-y: scroll;"
        mini-variant-width="90"
        width="300"
    >
        <v-list dense nav>
            <v-list-item style="padding:0px;" @click="getBonusDuck()">
                <v-list-item-avatar>
                    <v-icon v-if="bonusDuck" style="color: #ffd700;">
                        mdi-duck
                    </v-icon>
                    <img v-else src="../assets/logo.png" />
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>{{ appTitle }} </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn icon @click="toggleUserOptions('sidebar.isOpen')">
                        <v-icon>mdi-menu-open</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <template v-for="item in processedNavigationList">
                <!--First level-->
                <v-list-group
                    v-if="item.items && userHasPermission(item)"
                    :color="item.color"
                    v-show="userHasPermission(item)"
                >
                    <template v-slot:activator>
                        <v-list-item-icon>
                            <v-icon v-text="item.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title
                                v-text="item.title"
                            ></v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <!--Second level-->
                    <template v-for="child in item.items">
                        <v-list-group
                            v-if="child.items && userHasPermission(child)"
                            :color="child.color"
                            sub-group
                            no-action
                            v-show="userHasPermission(child)"
                        >
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title
                                        v-text="child.title"
                                    ></v-list-item-title>
                                </v-list-item-content>
                            </template>
                            <!--Third level-->
                            <template
                                v-for="(subChild, subChildindex) in child.items"
                            >
                                <v-list-item
                                    v-if="userHasPermission(subChild)"
                                    :key="subChildindex"
                                    :color="subChild.color"
                                    :to="subChild.route"
                                    exact
                                >
                                    <v-list-item-icon>
                                        <v-icon v-text="subChild.icon"></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            v-text="subChild.title"
                                        ></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list-group>
                        <!--Second level-->
                        <v-list-item
                            v-else
                            v-show="userHasPermission(child)"
                            :to="child.route"
                            :color="item.color"
                            no-action
                            exact
                            :class="item.color + '--text'"
                        >
                            <v-list-item-icon>
                                <v-icon v-text="child.icon"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ child.title }}
                                </v-list-item-title>
                                <v-list-item-subtitle
                                    v-if="child.badge"
                                    :class="`${child.badge.color}--text`"
                                >
                                    <v-icon
                                        v-if="child.badge.icon"
                                        v-text="child.badge.icon"
                                        dense
                                    ></v-icon>
                                    {{ child.badge.value }}
                                    {{ child.badge.text }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list-group>
                <!--First level-->
                <v-list-item
                    v-else
                    v-show="userHasPermission(item)"
                    :to="item.route"
                    :color="item.color"
                    no-action
                    exact
                >
                    <v-list-item-action>
                        <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title
                            v-text="item.title"
                        ></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
            <v-divider></v-divider>
            <v-spacer></v-spacer>
            <!--External link to technical support page
            <v-list-item
                href="https://unitedpetroleumtransport.atlassian.net/servicedesk/customer/portals"
                target="_blank"
                color="blue"
            >
                <v-list-item-action>
                    <v-icon color="blue">mdi-card-account-phone</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title class="blue--text"
                        >Contact IT Support</v-list-item-title
                    >
                </v-list-item-content>
            </v-list-item>-->
            <!--Logout-->
            <v-list-item
                v-if="isLoggedIn"
                @click="handleLogout"
                color="red"
                exact
            >
                <v-list-item-action>
                    <v-icon>mdi-logout</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import navigationData from '@/Utils/json/navigationBar.json';
import { mapGetters, mapActions } from 'vuex';
export default {
    name: 'AppNavigationNew',
    data() {
        return {
            userPermissions: [],
            bonusDuck: false,
            navigationList: navigationData || []
        };
    },
    computed: {
        ...mapGetters('auth', ['isLoggedIn']),
        ...mapGetters('app', ['userOptions', 'appTitle', 'version']),
        processedNavigationList() {
            return this.navigationList.map(navItem => ({
                ...navItem,
                items:
                    navItem.items && navItem.items.length > 0
                        ? navItem.items
                        : null
            }));
        }
    },
    mounted() {
        this.loadPermissions();
        this.setCatalogs();
    },
    methods: {
        ...mapActions('auth', ['logout']),
        ...mapActions('app', ['updateUserOption']),
        async handleLogout() {
            try {
                await this.logout();
                // Redirect to login page
            } catch (error) {
                console.error('Logout failed:', error);
            }
        },
        userHasPermission(item) {
            if (!item.permissions) {
                return true;
            }
            return item.permissions.some(permission =>
                this.userPermissions.includes(permission)
            );
        },
        loadPermissions() {
            let permissions = localStorage.getItem('permissions');
            if (permissions) {
                this.userPermissions = JSON.parse(permissions);
                console.log('User permissions found. Welcome back!');
            } else {
                console.error('Credentials not found...');
                this.$store.dispatch('setSnackbar', {
                    text: 'Credentials not found...',
                    color: 'error',
                    icon: 'mdi-alert-circle'
                });
            }
        },
        getRoleString(roles) {
            console.log(roles.join(' & '));
            return roles.join(' & ');
        },
        setCatalogs() {
            //Search for the catalogs item in the navigationList under System
            let system = this.navigationList.find(
                item => item.title === 'System Management'
            );
            let catalogs = system.items.find(item => item.title === 'Catalogs');
            //Set the items of the catalogs item in the navigationList
            let catalogItem = this.navigationList.find(
                item => item.title === 'Catalogs'
            );
            catalogItem.items = catalogs.items;
        },
        showSnackbar(message) {
            this.$store.dispatch('setSnackbar', {
                show: true,
                color: this.userOptions.darkTheme ? 'dark' : 'light',
                mode: 'multi-line',
                text: message
            });
        },
        toggleUserOptions(option) {
            const keys = option.split('.');
            let currentValue = this.userOptions;

            // Traverse the nested properties to get the current value
            for (let i = 0; i < keys.length - 1; i++) {
                if (!currentValue[keys[i]]) {
                    console.error(`Invalid key path: ${option}`);
                    return;
                }
                currentValue = currentValue[keys[i]];
            }

            // Toggle the final property in the path
            const finalKey = keys[keys.length - 1];
            const newValue = !currentValue[finalKey];
            // Call the Vuex action to update the state
            this.updateUserOption({
                key: option,
                value: newValue
            });
        },
        getBonusDuck() {
            if (this.bonusDuck) return;
            //Set the bonusDuck to true on a chance of 1 in 100
            if (Math.floor(Math.random() * 500) === 1) {
                this.bonusDuck = true;
                this.appTitle = 'Duck APP';
                //Dispatch a snackbar with the message "You found the bonus duck!"
                this.$store.dispatch('setSnackbar', {
                    text: 'You found the bonus duck!',
                    color: 'orange'
                });
                //Set the "primary" color for all the app to "gold"
                this.$vuetify.theme.themes.light.primary = '#ffd700';
                this.$vuetify.theme.themes.dark.primary = '#ffd700';
                this.$vuetify.theme.themes.light.accent = '#ffee00';
                this.$vuetify.theme.themes.dark.accent = '#ffee00';
                this.$vuetify.theme.themes.light.secondary = '#ffee00';
                this.$vuetify.theme.themes.dark.secondary = '#ffee00';
                this.$vuetify.theme.themes.light.success = '#ffee00';
                this.$vuetify.theme.themes.dark.success = '#ffee00';
                this.$vuetify.theme.themes.light.info = '#ffee00';
                this.$vuetify.theme.themes.dark.info = '#ffee00';
                this.$vuetify.theme.themes.light.warning = '#ffee00';
                this.$vuetify.theme.themes.dark.warning = '#ffee00';
                this.$vuetify.theme.themes.light.error = '#ffee00';
                this.$vuetify.theme.themes.dark.error = '#ffee00';
            }
        }
    }
};
</script>
<style></style>
